import executeRequest, { API_GetConfig, RequestOutput } from 'app/api'

type BoxParams = {
  size?: {
    w?: number
    h?: number
    d?: number
  },
  name?: string
  description?: string
}

export type API_GetMerchantParams = {
  content?: {
    title?: string
    customerTitle?: string
    customerDescription?: string
    returnTitle?: string
    returnDescription?: string
    pickupPointTitle?: string
    pickupPointDescription?: string,
  },
  thankYou?: {
    auto?: {
      title?: string
      description?: string
    }
    manual?: {
      title?: string
      description?: string
    }
  }
  field?: {
    [key: string]: {
      label?: string
      placeholder?: string
      description?: string
      helpDescription?: string
      s?: BoxParams
      m?: BoxParams
      l?: BoxParams
    }
  }
  boxOptions?: string[]
  modeOptions?: string[]
  acceptancePolicy?: string
  style?: {
    logoSize?: number
    backgroundColor?: string
  }
}

type GetMerchantParamsRequestParams = {
  locale: string
  merchantName: string
}
type GetMerchantParamsResponse = API_GetMerchantParams
enum GetMerchantParamsReponseError {
}
export async function getMerchantParams(params: GetMerchantParamsRequestParams, config?: API_GetConfig, output?: RequestOutput<GetMerchantParamsResponse, GetMerchantParamsReponseError>) {
  executeRequest({
    endpoint: config?.app.merchantUrl + params.merchantName + '.' + params.locale + '.json',
    config: config,
    params: params,
    output: output,
  })
}
